import React from "react";
import { observer } from "mobx-react-lite";
import { BooleanActionDetail } from "./components/BooleanActionDetail";
import { useTranslation } from "react-i18next";
export const SetPlayerInputActionDetail = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.node_set_ui_visible"),
    checked: action.uiVisible,
    toggle: () => action.setUiVisible(!action.uiVisible)
  }), /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.node_set_movement_enabled"),
    checked: action.movementEnabled,
    toggle: () => action.setMovementEnabled(!action.movementEnabled)
  }));
});